import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Radio } from '@dossierhq/design';
import { useId } from 'react';
import { SchemaEditorActions, } from '../../reducers/SchemaEditorReducer/SchemaEditorReducer.js';
export function NumberVariantSelector({ disabled, fieldSelector, integer, dispatchSchemaEditorState, }) {
    const name = useId();
    return (_jsxs(_Fragment, { children: [_jsx(Radio, { name: name, value: "float", checked: !integer, disabled: disabled, onChange: () => {
                    dispatchSchemaEditorState(new SchemaEditorActions.ChangeFieldInteger(fieldSelector, false));
                }, children: "Float" }), _jsx(Radio, { name: name, value: "integer", checked: integer, disabled: disabled, onChange: () => {
                    dispatchSchemaEditorState(new SchemaEditorActions.ChangeFieldInteger(fieldSelector, true));
                }, children: "Integer" })] }));
}
//# sourceMappingURL=NumberVariantSelector.js.map